import { UsersService } from "@/clients/services/UsersService";
import { LocalStorageKeys } from "@/constants/local-storage-keys";
import { QueryKeys } from "@/constants/query-keys";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useUploadAvatar = () => {
  const queryClient = useQueryClient();
  const cacheBustEventName = "avatar-cache-bust";

  const { mutate, mutateAsync, isPending, isError, error } = useMutation({
    mutationKey: [QueryKeys.USER],
    mutationFn: async (file: File) => {
      const user = guardGetUserFromLocalStorage();
      const { data } = await UsersService.uploadAvatarApiV1UsersAvatarPost(
        user.id,
        {
          avatar: file,
        },
      );

      return data;
    },
    onSuccess: () => {
      if (typeof window !== "undefined") {
        localStorage.setItem(
          LocalStorageKeys.AVATAR_CACHE_BUST_KEY,
          Date.now().toString(),
        );
        window.dispatchEvent(new Event(cacheBustEventName));
      }
      queryClient.invalidateQueries({ queryKey: [QueryKeys.USER] });
    },
  });

  return {
    uploadAvatar: mutate,
    uploadAvatarAsync: mutateAsync,
    isUploading: isPending,
    isError,
    error,
  };
};
